import { Box, ContentBlock, Text } from 'braid-design-system';
import slugify from 'slugify';

import { Link } from '../Link/Link';

import * as styles from './TabbedNav.css';
interface TabbedNavProps {
  links: ChildrenLink[];
  active: string;
}

interface ChildrenLink {
  path: string;
  name: string;
  element: JSX.Element;
}

export const TabbedNav = ({ links, active }: TabbedNavProps) => (
  <ContentBlock>
    <Box
      component="nav"
      style={{ overflowX: 'auto', scrollbarWidth: 'none' }}
      display="flex"
      justifyContent={{
        desktop: 'center',
      }}
      width="full"
    >
      {links.map((route, index) => {
        const isActive = route.name === active;
        return (
          <Link
            key={index}
            href={route.path}
            tracking={`${slugify(route.name, {
              lower: true,
            })}-link-clicked`}
          >
            <Box
              className={[styles.navItem, isActive && styles.navActive]}
              paddingX="small"
              paddingY="medium"
            >
              <Text tone={isActive ? 'link' : 'secondary'} weight="medium">
                {route.name}
              </Text>
            </Box>
          </Link>
        );
      })}
    </Box>
  </ContentBlock>
);
